import React from "react";

const ElecOffers = () => {
  return <div>
    
  </div>;
};

export default ElecOffers;
